import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';
import axios from '../lib/axios';

export default class ExportButton extends Component {
  static propTypes = {
    buttonLabel: PropTypes.string,
    buttonClassName: PropTypes.string,
    buttonIcon: PropTypes.string,
    buttonIconClassName: PropTypes.string,
    formSelector: PropTypes.string,
    url: PropTypes.string,
    method: PropTypes.string,
    action: PropTypes.string,
  };

  static defaultProps = {
    buttonLabel: '',
    buttonClassName: '',
    buttonIcon: null,
    buttonIconClassName: '',
    formSelector: null,
    url: null,
    method: null,
    action: null,
  }

  constructor(props) {
    super(props)

    this.buttonRef = React.createRef();
    this.state = {
      modalTriggered: false,
    };
  }

  handleClick = (e) => {
    if (this.buttonRef.current.contains(e.target)) {
      const action = this.props.action;

      const request = {
        url: this.props.url,
        method: this.props.method,
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      if (this.props.formSelector) {
        request.data = new FormData(document.querySelector(this.props.formSelector));
      }

      axios
        .request(request)
        .then((response) => {
          if (response.data.success) {
            this.setState({ modalTriggered: true });
            if (action) {
              $(`#${action}_card .export-info`).find('.error').hide();
            }
          } else {
            response.data.errors.forEach((error) => {
              $(`#${action}_card .export-info`).append(`<span class="error u-mb-0">${error.message}</span>`);
            });
          }
        });
    }
  }

  handleClose = () => {
    this.setState({ modalTriggered: false });
  }

  render() {
    const { buttonLabel, buttonClassName, buttonIcon, buttonIconClassName } = this.props;

    return (
      <button ref={this.buttonRef} onClick={this.handleClick} className={buttonClassName} type="button">
        {buttonIcon && <i className={`${buttonIcon} ${buttonIconClassName}`} />}
        {buttonLabel}
        { this.state.modalTriggered &&
          <Modal onClose={this.handleClose.bind(this)}>
            <div className="u-p-6">
              <h2 className="u-mb-4">
                Your export is on the way!
              </h2>
              <p className="u-text-base">When it's ready, your export will be delivered to <strong>{ this.props.currentUserEmail }</strong>.</p>
              <p className="u-text-base">Larger exports may take a few minutes.</p>

              <div className="u-flex u-justify-end">
                <button className="u-px-8 Button Button--primary Button--xsmall Modal-dismiss">
                  OK
                </button>
              </div>
            </div>
          </Modal>
        }
      </button>
    );
  }
}
